module.exports = __webpack_public_path__ + "img/progressPie_bg.5515ecc2.png";